import axios from "axios";
export default {
  namespaced: true,
  state: {
    low_stock_items: [],
    out_of_stock_items: [],
    healthy_stock_items: [],
    stock_summary: null,
    inventory_report: null,
  },
  getters: {
    low_stock_items(state) {
      return state.low_stock_items;
    },
    out_of_stock_items(state) {
      return state.out_of_stock_items;
    },
    healthy_stock_items(state) {
      return state.healthy_stock_items;
    },
    stock_summary(state) {
      return state.stock_summary;
    },
    inventory_report(state) {
      return state.inventory_report;
    },
  },
  mutations: {
    SET_LOW_STOCK_ITEMS(state, items) {
      state.low_stock_items = items;
    },
    SET_OUT_OF_STOCK_ITEMS(state, items) {
      state.out_of_stock_items = items;
    },
    SET_HEALTHY_STOCK_ITEMS(state, items) {
      state.healthy_stock_items = items;
    },
    SET_STOCK_SUMMARY(state, summary) {
      state.stock_summary = summary;
    },
    SET_INVENTORY_REPORT(state, report) {
      state.inventory_report = report;
    },
  },
  actions: {
    async get_low_stock_items({ commit }) {
      let response = await axios.get("/low_stock_items");
      commit("SET_LOW_STOCK_ITEMS", response.data);
    },
    async get_out_of_stock_items({ commit }) {
      let response = await axios.get("/out_of_stock_items");
      commit("SET_OUT_OF_STOCK_ITEMS", response.data);
    },
    async get_healthy_stock_items({ commit }) {
      let response = await axios.get("/healthy_stock_items");
      commit("SET_HEALTHY_STOCK_ITEMS", response.data);
    },
    async get_stock_summary({ commit }) {
      let response = await axios.get("/stock_summary");
      commit("SET_STOCK_SUMMARY", response.data);
    },
    async get_inventory_report({ commit }, params = {}) {
      let response = await axios.get("/inventory_valuation_report", { params });
      commit("SET_INVENTORY_REPORT", response.data);
      return response.data;
    },
    async update_reorder_point(_, request) {
      let response = await axios.put("/update_reorder_point", request);
      return response.data;
    },
    async bulk_update_reorder_points(_, request) {
      let response = await axios.put("/bulk_update_reorder_points", request);
      return response.data;
    },
  },
};
